<template>
  <!-- 维护提示弹窗 -->
  <div class="dialog_box">
    <div class="mark_box" />
    <div class="content_box">
      <p class="title">{{ $t('warningInfo.maint_tips') }}</p>
      <i v-if="showConfirm" class="el-icon-check click" @click="handleMaint(2)" />
      <i v-else class="el-icon-close click" @click="$emit('close')" />

      <p class="text"> {{ warn_text }}</p>

      <div class="btn_box">
        <div class="btn click back" @click="handleMaint(1)">{{ $t('warningInfo.maintained') }}</div>
        <div v-if="showDatePicker" class="btn click back">
          <span>{{ willMaint }}</span>
          <i class="el-icon-date" />
          <el-date-picker
            v-model="value"
            class="date_picker"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @blur="changeDate"
            @change="change"
          />
        </div>
        <div class="btn click" @click="handleMaint(3)">{{ $t('warningInfo.ignore') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleVehicleMaintenanceMsg } from '@/api/allDevice'
export default {
  props: ['maintObj'],
  data() {
    return {
      value: '',
      value1: '',
      showConfirm: false,
      warn_text: '',
      showDatePicker: true,
      pickerOptions: {
        disabledDate(val) {
          return val.getTime() < new Date().getTime()
        }
      }
    }
  },
  computed: {
    willMaint() {
      // let lang = this.$locale.lang
      const str = this.$t('warningInfo.willbe_maintained')
      return str.replace('$1', this.value1)
    }
  },
  mounted() {
    console.log('maintObj:', this.maintObj)

    // this.typeName = this.maintObj.msgType == 704 ? this.$t('warningInfo.periodic_vehicles') : this.$t('warningInfo.battery_maint')
    if (this.maintObj.msgType == 704) {
      this.warn_text = this.$t('warningInfo.your') + this.$t('warningInfo.periodic_vehicles') + this.$t('warningInfo.maint_text')
    } else if (this.maintObj.msgType == 705) {
      if (this.maintObj.triggerValue == 1) { // 周期性
        this.warn_text = this.$t('warningInfo.your') + this.$t('warningInfo.battery_maint') + '-' + this.$t('warningInfo.periodic_maint') + this.$t('warningInfo.maint_text')
      } else { // 容量
        this.warn_text = this.$t('warningInfo.your') + this.$t('warningInfo.battery_maint') + '-' + this.$t('warningInfo.capacity_maint') + this.$t('warningInfo.maint_text')
      }
    } else if (this.maintObj.msgType == 706) {
      this.warn_text = this.$t('warningInfo.your') + this.$t('warningInfo.battery_not_used') + '，' + this.$t('warningInfo.maint_text2')
    }

    if (this.maintObj.triggerValue == 2) {
      this.showDatePicker = false
    }

    const now = new Date()
    const date = new Date(now.getTime() + 1000 * 60 * 60 * 24)
    const year = date.getFullYear() // 获取完整的年份(4位)
    const month = date.getMonth() + 1 // 获取当前月份(0-11,0代表1月)
    const day = date.getDate() // 获取当前日(1-31)
    this.value1 = year + '-' + month + '-' + day
  },
  methods: {
    changeDate() {
      this.showConfirm = true
    },
    change(val) {
      console.log(val)
      if (!val) return
      this.value1 = val
    },
    handleMaint(type) {
      this.$emit('close')

      const time = new Date(this.value1)
      console.log(time.getTime())
      handleVehicleMaintenanceMsg({
        'date': time.getTime(),
        'id': this.maintObj.id,
        'type': type
      }).then(res => {
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_box {
  .mark_box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color: #000000, $alpha: 0.2);
    z-index: 99;
  }
  .content_box {
    width: 50%;
    max-width: 600px;
    height: 360px;
    border-radius: 10px;
    background-color: #fff;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    margin: auto;
    text-align: center;
    padding: 20px;
    .el-icon-close,
    .el-icon-check {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 20px;
    }
    .title {
      font-size: 15px;
      padding-bottom: 20px;
      border-bottom: 1px solid #e4e4e4;
    }
    .text {
      padding: 20px 30px;
      font-size: 13px;
      line-height: 30px;
    }
    .btn_box {
      width: 60%;
      margin: 0 auto;
      padding-top: 10px;
      .btn {
        border-radius: 30px;
        line-height: 30px;
        margin-bottom: 14px;
        position: relative;
      }
      .back {
        background-color: #f4f4f4;
        color: #1890ff;
      }
      .el-icon-date {
        position: absolute;
        right: 10px;
        top: 8px;
        z-index: 1;
      }
      .date_picker {
        position: absolute;
        z-index: 9;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        cursor: pointer;
        opacity: 0;
        width: 100%;
      }
    }
  }
}

// .theme-light {
//   .dialog_box {
//     .mark_box {
//       background-color: rgba($color: #000000, $alpha: 0.2);
//     }
//     .content_box {
//       background-color: #fff;
//     }
//     .btn_box .back {
//       background-color: #f4f4f4;
//     }
//     .title {
//       border-color: #e4e4e4;
//     }
//   }
// }

// 移动端
@media screen and (max-width: 1279px) {
  .dialog_box .content_box {
    width: 62%;
  }
}
</style>
